import { CalendarAreaProvider } from "@/pages/mill/schedule/calendar/context/CalendarAreaContext";
import { CustomCalendar } from "@/pages/mill/schedule/calendar/custom_calendar";
import { MILL_1, MILL_2 } from "@/setup/mill-config/mill-config";

export const routeCalendar = "/calendar";
export const routeCalendarM1 = "/calendar/m1";
export const routeCalendarM2 = "/calendar/m2";
export const calendarSalesPermission = "ui.navbar.calendar.sales";
export const calendarPermission = "ui.navbar.calendar";

const M1Calendar = () => (
	<CalendarAreaProvider areaId={MILL_1.id}>
		<CustomCalendar />
	</CalendarAreaProvider>
);

const M2Calendar = () => (
	<CalendarAreaProvider areaId={MILL_2.id}>
		<CustomCalendar />
	</CalendarAreaProvider>
);

export const calendarRoute = [
	{
		path: routeCalendar,
		element: <CustomCalendar />,
		permission: calendarPermission,
	},
	{
		path: routeCalendarM1,
		element: <M1Calendar />,
		permission: calendarSalesPermission,
	},
	{
		path: routeCalendarM2,
		element: <M2Calendar />,
		permission: calendarSalesPermission,
	},
];
